const tooltips = {
    'tooltip.edit': 'Edit',
    'tooltip.delete': 'Delete',
    'tooltip.login_as': 'Login as',
    'tooltip.activate': 'Activate',
    'tooltip.deactivate': 'Deactivate',
    'tooltip.all_products': 'All products',
    'tooltip.sync': 'Synchronise',
    'tooltip.category': 'Categories',
    'tooltip.brand': 'Brands',
    'tooltip.attributes': 'Attributes',
    'tooltip.price_settings': 'Price settings',
    'tooltip.combine': 'Combine fields',

    'tooltip.append': 'Combine more',
    'tooltip.create': 'Create new',

    'tooltip.product.requires_sync': 'Sync required for pending changes.',
    'tooltip.product.is_modified': 'This product contains changes.',

    'tooltip.last_sync': 'Last sync',
    'tooltip.last_update': 'Last update',

    'tooltip.allow_custom_subscription_option': 'Allow subscription option for this client.',
    'tooltip.disallow_custom_subscription_option': 'Disallow subscription option for this client.',

    'tooltip.subscription_valid_until': 'Subscription valid until:',
};

export default tooltips;
